import AOS from 'aos';

// AOS init
AOS.init({ once: true });

document.addEventListener('aos:in:stats', () => {
    $('.js-count').each(function H() {
        $(this).prop('Counter', 0).animate({ Counter: $(this).text() }, {
            duration: 3000,
            easing: 'linear',
            step: function H(now) {
                $(this).text(Math.ceil(now));
            }
        });
    });
});

document.addEventListener('aos:in:cwi', () => {
    $('.js-cwi').addClass('visible');
});

document.addEventListener('aos:in:ht2', () => {
    $('.js-ht2').addClass('visible');
});
